import { Box, Grid, Tooltip, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import ProfilePic from '../../ProfilePic';
import '../../Shimmer/HelpandSupportShimmer/Shimmer.css';

interface NetworkCompanyType {
	companyId: string;
	relationName: string;
	isMeSender: boolean;
	companyName: string;
	count: {
		category: number;
		article: number;
		video: number;
		podcast: number;
		document: number;
	};
}

interface CompanyItemProps {
    company: NetworkCompanyType;
    onSelect: (company: NetworkCompanyType) => void;
    onMouseEnter: () => void;
}

const CompanyItem: React.FC<CompanyItemProps> = ({ company, onSelect, onMouseEnter }) =>
{
	const [ isImageLoaded, setIsImageLoaded ] = useState(false);

	const handleImageLoad = () =>
	{
		setIsImageLoaded(true);
	};

	return (
		<Box
			onClick={() => onSelect(company)}
			onMouseEnter={onMouseEnter}
			sx={{
				cursor       : 'pointer',
				padding      : '8px 12px',
				borderRadius : '4px',
				'&:hover'    : {
					backgroundColor : '#F5F5F5'
				}
			}}
		>
			<Grid container direction='row' display={'flex'} alignItems='center' spacing={1}>
				<Grid item mr={1} sx={{ width: '32px', height: '32px' }}>
					<ProfilePic
						imagePath={`${company.companyId}_logo_thumbnail.jpeg`}
						defaultImg='/images/logos/no_logo.png'
						alt={company.companyName || 'Company'}
						style={{ width: '32px', height: '32px' }}
						className={`brdrRadius50 ${isImageLoaded ? '' : 'shimmer'}`}

						onLoad={handleImageLoad}
					/>
				</Grid>
				<Grid item minWidth={0} px={1}>
					<Tooltip title={company.companyName || ''} arrow>
						<Typography
							fontSize='var(--pixel14)'
							color='var(--darkgray)'
							noWrap
							sx={{
								overflow     : 'hidden',
								textOverflow : 'ellipsis',
								whiteSpace   : 'nowrap',
								maxWidth     : '150px', // adjust as needed for your layout
								display      : 'block'
							}}
						>
							{company.companyName || ''}
						</Typography>
					</Tooltip>
				</Grid>
			</Grid>
		</Box>
	);
};

export default CompanyItem;